import axios from 'axios';
import { getTokenHeader, getToken } from '../../../../screen/auth/action';
import { getCompanySuppliersUrl } from '../../../../v2/BCMOrder/APIs/API';

export const getCompanySuppliersAction = async (
  module = 'default',
  params = {},
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    if (params instanceof URLSearchParams) {
      params.append('module', module);
    } else {
      params = new URLSearchParams(params);
      params.append('module', module);
    }
    await axios
      .get(getCompanySuppliersUrl(), {
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};